module.exports = __webpack_public_path__ + "img/20_70.b4e195f9.png";